module.exports = __webpack_public_path__ + "img/manajemen_keuangan.ce228e3d.svg";